function CircularLoadingIcon({
  size = 24,
  color = "rgb(25, 118, 210)",
  rotate = true,
}) {
  const svgStyles = {
    width: size,
    height: size,
    fill: color,
    animation: rotate ? "rotate 2s linear infinite" : "none",
  };
  const keyframes = `
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
  return (
    <>
      <style>{keyframes}</style>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={svgStyles}
        viewBox="0 0 256 256"
      >
        <path d="M236,128a108,108,0,0,1-216,0c0-42.52,24.73-81.34,63-98.9A12,12,0,1,1,93,50.91C63.24,64.57,44,94.83,44,128a84,84,0,0,0,168,0c0-33.17-19.24-63.43-49-77.09A12,12,0,1,1,173,29.1C211.27,46.66,236,85.48,236,128Z"></path>
      </svg>
    </>
  );
}

export default CircularLoadingIcon;
